// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.example {
   max-height: 85vh;
   display: flex;
}

.blur {
   opacity: 0.5;
}

.can-not-preview {
   padding: 2em;
   text-align: center;
}
.preview-error {
   color: #1b2733;
   font-size: 18px;
   margin: 8px;
}
.preview-error-info {
   color: #637282;
}
.hide{
   display: none;
}
.show{
   display: block;
}

.height-sign {
   height: 510px;
}

.height-dialog {
   height: 420px;
}

.example-container {
   width: 100%;
   max-height: 100vh;
   overflow: hidden;
   display: flex;
}

.example-sidenav {
   padding: 20px;
}

text {
   -webkit-touch-callout: none; /* iOS Safari */
   -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Firefox */ /* Internet Explorer/Edge */
   user-select: none;
   /* Non-prefixed version, currently supported by Chrome and Opera */
}

.menu > li > a {
   cursor: pointer;
   display: block;
   padding: 5px 1em;
   position: relative;
   white-space: nowrap;
}

.menu > li > a:hover {
   background-color: #f7f7f7;
   color: #3d464d;
   text-decoration: none;
}

.toolbar .dropdown.open > a {
   background-color: #ebebeb;
   border-color: #bdc3c7;
}

.menu > li > a > i {
   font-size: 16px;
   margin-right: 10px;
}

.menu button {
   padding: 0 12px;
}

.menu button.mat-primary {
   line-height: 30px;
}

.menu button:not(.mat-primary) {
   line-height: 28px;
}

.menu button i {
   font-size: 16px;
   margin-right: 10px;
}

.toolbar {
   left: auto;
   right: 0;
   list-style: none;
   z-index: 10;
}

@media print {
   @page {
      margin: 0;
   }

   body {
      margin: 1.6cm;
   }
}

.sign-page {
   display: block;
   margin: 0 auto;
   position: relative;
   overflow: auto;
}

.page-transform-group {
   text-align: center;
}

.page-action-group {
   margin-left: 700px;
}

.page-action-close {
   margin-left: 80px;
}

.center {
   position: absolute;
   top: 50%;
   left: 50%;
}

.svg_select_boundingRect {
   stroke-width: 1;
   fill: gray;
   stroke-dasharray: 10 10;
   stroke: black;
   stroke-opacity: 0.8;
   fill-opacity: 0.1;
   pointer-events: none; /* This ons is needed if you want to deselect or drag the shape*/
}

tspan {
   font-family: "TH Sarabun PSK", sans-serif !important;
}

.overlay {
   position: absolute;
   top: 40%;
   left: 50%;
   opacity: .75;
   z-index: 2;
}

::ng-deep .mat-horizontal-content-container {
   overflow: hidden;
   padding: 0 0px 0px 0px;
}

::ng-deep .mat-stepper-horizontal, .mat-stepper-vertical {
   height: 100%;
}

#pano {
   display: none;
   position: fixed;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   z-index: 2;
}

.side-nav {
   width: 100%;
   position: static;
}

.header-view-document {
   top: 0;
}

#block-sign-page {
   margin-top: 45px
}

.document-container {
   position: relative;
}

.comment-container {
   position: absolute;
   top: 0;
   width: 280px;
}

.watermark {
   position: relative;
   overflow: hidden;
 }

.block-form {
   height: auto;
   margin-left: 25px;
   margin-top: 50px;
}

.block-form-container {
   display: flex;
   justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/sign-off/create-task-sign-off/create-task-sign-off.component.css"],"names":[],"mappings":"AAAA;GACG,gBAAgB;GAChB,aAAa;AAChB;;AAEA;GACG,YAAY;AACf;;AAEA;GACG,YAAY;GACZ,kBAAkB;AACrB;AACA;GACG,cAAc;GACd,eAAe;GACf,WAAW;AACd;AACA;GACG,cAAc;AACjB;AACA;GACG,aAAa;AAChB;AACA;GACG,cAAc;AACjB;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,WAAW;GACX,iBAAiB;GACjB,gBAAgB;GAChB,aAAa;AAChB;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,2BAA2B,EAAE,eAAe;GAC5C,yBAAyB,EAAE,WAAW,EACZ,mBAAmB,EACrB,YAAY,EACb,2BAA2B;GAClD,iBAAiB;GACjB,kEAAkE;AACrE;;AAEA;GACG,eAAe;GACf,cAAc;GACd,gBAAgB;GAChB,kBAAkB;GAClB,mBAAmB;AACtB;;AAEA;GACG,yBAAyB;GACzB,cAAc;GACd,qBAAqB;AACxB;;AAEA;GACG,yBAAyB;GACzB,qBAAqB;AACxB;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,UAAU;GACV,QAAQ;GACR,gBAAgB;GAChB,WAAW;AACd;;AAEA;GACG;MACG,SAAS;GACZ;;GAEA;MACG,aAAa;GAChB;AACH;;AAEA;GACG,cAAc;GACd,cAAc;GACd,kBAAkB;GAClB,cAAc;AACjB;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,kBAAkB;GAClB,QAAQ;GACR,SAAS;AACZ;;AAEA;GACG,eAAe;GACf,UAAU;GACV,uBAAuB;GACvB,aAAa;GACb,mBAAmB;GACnB,iBAAiB;GACjB,oBAAoB,EAAE,gEAAgE;AACzF;;AAEA;GACG,oDAAoD;AACvD;;AAEA;GACG,kBAAkB;GAClB,QAAQ;GACR,SAAS;GACT,YAAY;GACZ,UAAU;AACb;;AAEA;GACG,gBAAgB;GAChB,sBAAsB;AACzB;;AAEA;GACG,YAAY;AACf;;AAEA;GACG,aAAa;GACb,eAAe;GACf,MAAM;GACN,OAAO;GACP,WAAW;GACX,YAAY;GACZ,UAAU;AACb;;AAEA;GACG,WAAW;GACX,gBAAgB;AACnB;;AAEA;GACG,MAAM;AACT;;AAEA;GACG;AACH;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,kBAAkB;GAClB,MAAM;GACN,YAAY;AACf;;AAEA;GACG,kBAAkB;GAClB,gBAAgB;CAClB;;AAED;GACG,YAAY;GACZ,iBAAiB;GACjB,gBAAgB;AACnB;;AAEA;GACG,aAAa;GACb,uBAAuB;AAC1B","sourcesContent":[".example {\n   max-height: 85vh;\n   display: flex;\n}\n\n.blur {\n   opacity: 0.5;\n}\n\n.can-not-preview {\n   padding: 2em;\n   text-align: center;\n}\n.preview-error {\n   color: #1b2733;\n   font-size: 18px;\n   margin: 8px;\n}\n.preview-error-info {\n   color: #637282;\n}\n.hide{\n   display: none;\n}\n.show{\n   display: block;\n}\n\n.height-sign {\n   height: 510px;\n}\n\n.height-dialog {\n   height: 420px;\n}\n\n.example-container {\n   width: 100%;\n   max-height: 100vh;\n   overflow: hidden;\n   display: flex;\n}\n\n.example-sidenav {\n   padding: 20px;\n}\n\ntext {\n   -webkit-touch-callout: none; /* iOS Safari */\n   -webkit-user-select: none; /* Safari */\n   -khtml-user-select: none; /* Konqueror HTML */\n   -moz-user-select: none; /* Firefox */\n   -ms-user-select: none; /* Internet Explorer/Edge */\n   user-select: none;\n   /* Non-prefixed version, currently supported by Chrome and Opera */\n}\n\n.menu > li > a {\n   cursor: pointer;\n   display: block;\n   padding: 5px 1em;\n   position: relative;\n   white-space: nowrap;\n}\n\n.menu > li > a:hover {\n   background-color: #f7f7f7;\n   color: #3d464d;\n   text-decoration: none;\n}\n\n.toolbar .dropdown.open > a {\n   background-color: #ebebeb;\n   border-color: #bdc3c7;\n}\n\n.menu > li > a > i {\n   font-size: 16px;\n   margin-right: 10px;\n}\n\n.menu button {\n   padding: 0 12px;\n}\n\n.menu button.mat-primary {\n   line-height: 30px;\n}\n\n.menu button:not(.mat-primary) {\n   line-height: 28px;\n}\n\n.menu button i {\n   font-size: 16px;\n   margin-right: 10px;\n}\n\n.toolbar {\n   left: auto;\n   right: 0;\n   list-style: none;\n   z-index: 10;\n}\n\n@media print {\n   @page {\n      margin: 0;\n   }\n\n   body {\n      margin: 1.6cm;\n   }\n}\n\n.sign-page {\n   display: block;\n   margin: 0 auto;\n   position: relative;\n   overflow: auto;\n}\n\n.page-transform-group {\n   text-align: center;\n}\n\n.page-action-group {\n   margin-left: 700px;\n}\n\n.page-action-close {\n   margin-left: 80px;\n}\n\n.center {\n   position: absolute;\n   top: 50%;\n   left: 50%;\n}\n\n.svg_select_boundingRect {\n   stroke-width: 1;\n   fill: gray;\n   stroke-dasharray: 10 10;\n   stroke: black;\n   stroke-opacity: 0.8;\n   fill-opacity: 0.1;\n   pointer-events: none; /* This ons is needed if you want to deselect or drag the shape*/\n}\n\ntspan {\n   font-family: \"TH Sarabun PSK\", sans-serif !important;\n}\n\n.overlay {\n   position: absolute;\n   top: 40%;\n   left: 50%;\n   opacity: .75;\n   z-index: 2;\n}\n\n::ng-deep .mat-horizontal-content-container {\n   overflow: hidden;\n   padding: 0 0px 0px 0px;\n}\n\n::ng-deep .mat-stepper-horizontal, .mat-stepper-vertical {\n   height: 100%;\n}\n\n#pano {\n   display: none;\n   position: fixed;\n   top: 0;\n   left: 0;\n   width: 100%;\n   height: 100%;\n   z-index: 2;\n}\n\n.side-nav {\n   width: 100%;\n   position: static;\n}\n\n.header-view-document {\n   top: 0;\n}\n\n#block-sign-page {\n   margin-top: 45px\n}\n\n.document-container {\n   position: relative;\n}\n\n.comment-container {\n   position: absolute;\n   top: 0;\n   width: 280px;\n}\n\n.watermark {\n   position: relative;\n   overflow: hidden;\n }\n\n.block-form {\n   height: auto;\n   margin-left: 25px;\n   margin-top: 50px;\n}\n\n.block-form-container {\n   display: flex;\n   justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
